/**
 * 分包合同逐页缩写：由签署人填写的姓名生成字样，免去手机上反复手写缩写的操作。
 * 这里只生成图片；每页是否确认仍由签署组件在用户点击后请求服务端记录。
 */

/** 英文取各姓名词的首字母；汉字保留原文，避免未经本人确认就猜测多音字拼音。 */
export function initialsFromName(name) {
  const words = String(name || "").normalize("NFC").match(/\p{L}[\p{L}\p{M}]*(?:['’]\p{L}[\p{L}\p{M}]*)*/gu) || [];
  return words.map(word => /\p{Script=Han}/u.test(word) ? word : Array.from(word)[0].toUpperCase()).join("");
}

/**
 * 将姓名缩写转为透明 PNG，继续复用现有逐页确认、哈希核验及 PDF 盖签接口。
 * 同一次姓名使用同一张图片；不能每次翻页重新生成，否则字体加载可能改变图片哈希。
 */
export function initialsPng(initials) {
  if (!initials) throw new Error("请先填写签署人真实姓名 / Enter your full name first");
  const canvas = document.createElement("canvas");
  canvas.width = 600; canvas.height = 160;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("无法生成姓名缩写，请重试 / Unable to generate initials. Please retry");
  context.font = "italic 600 96px serif";
  context.fillStyle = "#1e1b4b"; // 与现有手写签名的墨色一致，透明底不会遮盖合同条款。
  context.textAlign = "center";
  context.textBaseline = "middle";
  context.fillText(initials, canvas.width / 2, canvas.height / 2, canvas.width - 48);
  return canvas.toDataURL("image/png");
}
